import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MassCreateChargingStationDialogContentComponent } from './mass-create-charging-station-dialog-content/mass-create-charging-station-dialog-content.component';

@Component({
  selector: 'app-mass-create-chargingstation-dialog',
  template: ''
})
export class MassCreateChargingStationDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;

    const dialogRef = this.dialog.open(MassCreateChargingStationDialogContentComponent, { centered: true, backdrop: 'static', size:'lg' });

    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
